// The removable ad-hoc labels of a ShareJet booking (Payment required, MGAV overdue, New seats, Passport needed).
import { Space, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import type { AdminBookingDetail } from '../../api/types';
import { ADHOC_COLORS, AdhocTag } from '../../components/AdhocTag';
import type { UpdateBody } from './bookingUpdate';

const { Text } = Typography;

export function BookingAdhocTags({
  b,
  mut,
  removeAdhoc,
}: {
  b: AdminBookingDetail;
  mut: { isPending: boolean };
  removeAdhoc: (body: UpdateBody, label: string) => void;
}) {
  return (
    <Space size={4} wrap>
      {/* SHAR-1089 — "Payment required" shows here as on the bookings list, and
          SHAR-1088 — it is removable the same way; it comes back when another
          pre-authorisation expires. */}
      {b.notPaid ? (
        <AdhocTag
          color="red"
          label="Payment required"
          title="Remove label"
          description="Remove the “Payment required” label from this booking? It comes back if another pre-authorisation expires."
          loading={mut.isPending}
          onRemove={() => removeAdhoc({ dismissPaymentRequired: true }, 'Payment required')}
        />
      ) : null}
      {b.mgavOverdue ? (
        <AdhocTag
          color="volcano"
          icon={<WarningOutlined />}
          label="MGAV overdue"
          title="Remove label"
          description="Remove the “MGAV overdue” label from this booking?"
          loading={mut.isPending}
          onRemove={() => removeAdhoc({ dismissMgavOverdue: true }, 'MGAV overdue')}
        />
      ) : null}
      {b.newSeats ? (
        <AdhocTag
          color="gold"
          label="New seats booked"
          title="Remove label"
          description="Remove the “New seats booked” label from this booking?"
          loading={mut.isPending}
          onRemove={() => removeAdhoc({ clearNewSeats: true }, 'New seats booked')}
        />
      ) : null}
      {/* SHAR-453 — "Passport needed" also shows in booking details (it already
          shows in the bookings list). SHAR-452 — manual removal (×), consistent
          with the other ad-hoc statuses. */}
      {b.passportNeeded ? (
        <AdhocTag
          color={ADHOC_COLORS.passportNeededDetail}
          label="Passport needed"
          title="Remove label"
          description="Remove the “Passport needed” label from this booking?"
          loading={mut.isPending}
          onRemove={() => removeAdhoc({ dismissPassportNeeded: true }, 'Passport needed')}
        />
      ) : null}
      {!b.mgavOverdue && !b.newSeats && !b.passportNeeded && !b.notPaid ? (
        <Text type="secondary">—</Text>
      ) : null}
    </Space>
  );
}
